import { get } from 'lodash';
import { useCompany } from './useCompany';
import { useCompanyCanonicalUrl } from './useCompanyCanonicalUrl';
import { PRIMARY_INDUSTRIES } from '@/constants/industries';
import {
  ROUTE_COMPANY,
  ROUTE_STOCKS_HOME,
  ROUTE_STOCKS_MARKET,
  ROUTE_STOCKS_MARKET_INDUSTRY,
} from '@/constants/routes';
import { PRIMARY_MARKETS } from '@/constants/markets';
import useCompanyVariant from './useCompanyVariant';

export function useBreadcrumbs() {
  const canonicalUrl = useCompanyCanonicalUrl();
  const urlHash = useCompanyVariant(canonicalUrl + 'breadcrumb');
  const showExperiment = parseInt(urlHash, 16) <= 7;
  const { data: company, status } = useCompany(canonicalUrl);
  if (status !== 'success') return { status };
  const {
    data: {
      name,
      unique_symbol: uniqueSymbol,
      info: {
        data: {
          industry: { primary_id: industryId },
        },
      },
    },
  } = company;
  const industryData =
    industryId !== null && typeof industryId !== 'undefined'
      ? PRIMARY_INDUSTRIES[industryId]
      : null;

  const [_, stocks, market, industry, ticker, companyName] =
    company.data.canonical_url.split('/');

  const readableCountry = get(PRIMARY_MARKETS, [market, 'label'], 'Global');

  const stocksCrumb = {
    name: 'Stocks',
    canonicalUrl: `/${stocks}/`,
    dispatch: {
      type: ROUTE_STOCKS_HOME,
      payload: {},
    },
  };

  const marketCrumb = {
    name: readableCountry,
    canonicalUrl: `/${stocks}/${market}`,
    dispatch: {
      type: ROUTE_STOCKS_MARKET,
      payload: {
        market: market,
      },
    },
  };

  const stocksCrumbExperiment = {
    name: 'Stocks',
    canonicalUrl: `/${stocks}/${market}`,
    dispatch: {
      type: ROUTE_STOCKS_MARKET,
      payload: {
        market: market,
      },
    },
  };

  const selectedCrumbs = showExperiment
    ? [stocksCrumbExperiment]
    : [stocksCrumb, marketCrumb];

  const breadcrumbs = [
    ...selectedCrumbs,
    ...(industryData?.label
      ? [
          {
            name: industryData.label,
            canonicalUrl: industryData.label
              ? `/${stocks}/${market}/${industry}`
              : '',
            dispatch: {
              type: ROUTE_STOCKS_MARKET_INDUSTRY,
              payload: {
                market: market || undefined,
                industry: industry || undefined,
              },
            },
          },
        ]
      : []),
    {
      name: `${name} ${uniqueSymbol}`,
      canonicalUrl,
      documentSchemaOnly: true,
      dispatch: {
        type: ROUTE_COMPANY,
        payload: {
          isoCode2: market || undefined,
          industry: industry || undefined,
          exchange_ticker: ticker || undefined,
          companyname: companyName || undefined,
        },
      },
    },
  ];
  return { status: 'success', breadcrumbs };
}
